import React, { ReactNode, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/useAuthStore';
import { usePermissionStore } from '../../store/usePermissionStore';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const permissions = usePermissionStore((state) => state.permissions);
  const isLoading = usePermissionStore((state) => state.isLoading);
  const hasFetched = usePermissionStore((state) => state.hasFetched);
  const fetchPermissions = usePermissionStore((state) => state.fetchPermissions);

  console.log('[ProtectedRoute] Render - isAuthenticated:', isAuthenticated, 'hasFetched:', hasFetched, 'isLoading:', isLoading);

  useEffect(() => {
    console.log('[ProtectedRoute] useEffect - isAuthenticated:', isAuthenticated, 'hasFetched:', hasFetched, 'isLoading:', isLoading);
    if (isAuthenticated && !hasFetched && !isLoading) {
      console.log('[ProtectedRoute] Fetching permissions');
      fetchPermissions();
    }
  }, [isAuthenticated, hasFetched, isLoading, fetchPermissions]);

  if (!isAuthenticated) {
    console.log('[ProtectedRoute] Not authenticated, redirecting to /signin');
    return <Navigate to="/signin" replace />;
  }

  console.log('[ProtectedRoute] Authenticated, rendering children');
  return <>{children}</>;
};

export default ProtectedRoute;
